<template>

  <div >
    <div class="beneficary-details-page">
      <div class="left">
        <h1>
        
          {{ this.beneficiary.last_name + " " + this.beneficiary.first_name }}
        </h1>
      </div>
      <div class="right">
        
      </div>
      <br />
      <br />
      <div :class="!this.beneficiary.active && 'benef'">
        <div class="container-alb">
          <table width="95%" align="center" cellpadding="10" cellspacing="0">
            <tr>
              <td align="left">
                <small>{{ $t("lastNameField") }}</small>
                <br />
                <input
                  id="beneficiaryLastName"
                  type="text"
                  v-model="formData.lastName"
                  class="formedituser"
                  disabled
                  @keyup="updateInputCharacters()"
                />
              </td>
              <td align="left">
                <small>{{ $t("surnameFieldLabel") }}</small>
                <br />
                <input
                  type="text"
                  id="beneficiaryFirstName"
                  v-model="formData.firstName"
                  class="formedituser"
                  disabled
                  @keyup="updateInputCharacters()"
                />
              </td>
              <td align="left">
                <small>{{ $t("cnpFieldLabel") }}</small>
                <br />
                <input
                  type="text"
                  :value="beneficiary.cnp"
                  class="formedituser"
                  disabled
                  @keyup="updateInputCharacters()"
                />
              </td>
            </tr>

            <!-- <tr>
              <td align="left">
                <small>{{ $t("mobileField") }}</small>
                <br />
                <input
                  type="text"
                  id="beneficiaryMobilePhone"
                  v-model="formData.mobilePhone"
                  class="formedituser"
                  disabled
                  @keyup="updateInputCharacters()"
                />
              </td>
              <td align="left">
                <small>{{ $t("emailField") }}</small>
                <br />
                <input
                  type="text"
                  id="beneficiaryEmail"
                  v-model="formData.email"
                  class="formedituser"
                  disabled
                />
              </td>
            </tr> -->
          </table>

        </div>
        <div class="loading" v-if="this.beneficiaryPlus === null">
          <img src="@/assets/images/loading.gif" />
        </div>
        <div v-else-if="this.beneficiary.modules" class="container-alb" >
          <div style="margin-left: 30px;">
            <h3>{{ $t('activeModulesPlus') }}
              <span style="font-size:medium; font-weight: normal;">
            <template v-for="(module, name) in this.beneficiary.modules">
                  {{ (module ? (name + " / ") : "") }}
              </template>
            </span>
            </h3>
            <h3>{{ $t('activePagoId') }}
              <span style="font-size:medium; font-weight: normal;" v-if="this.beneficiaryPlus.pago_id">
                  {{ this.beneficiaryPlus.pago_id }}
            </span>
            </h3>
            <h3>{{ $t('activeNotificationsCore') }}
              <span style="font-size:medium; font-weight: normal;">
                <template v-for="(module, name) in this.beneficiaryPlus.app_settings.notification.application_channels">
                  {{ (module ? (name + " / ") : "") }}
                </template>
              </span>
            </h3>
            <h3>{{ $t('activeNotificationsMarketing') }}
              <span style="font-size:medium; font-weight: normal;">
                <template v-for="(module, name) in this.beneficiaryPlus.app_settings.notification.marketing_channels">
                  {{ (module ? (name + " / ") : "") }}
                </template>
              </span>
            </h3>
            <h3>{{ $t('activeAccountLoginsPlus') }}</h3>

          </div>
          <BeneficiaryAccountsTable
          :accounts="this.beneficiaryPlus.accounts"
          @change="sortBy(sortField, sortDirection)"
          />
          <br />
          <table cellpadding="10" cellspacing="0" width="95%" align="center">
            <tr>
              <td>
                <a 
                      class="notification-action custom-notification-action"
                      @click="
                        showDeleteMobileAccountPopup()
                        "
                      >{{ $t("deleteAccountLabel") }}</a
                      >
              </td>
              
            </tr> 
          </table>
        </div>
        <div class="loading" v-if="this.beneficiary.core_data && !this.accountLoaded">
          <img src="@/assets/images/loading.gif" />
        </div>
        <div v-else>
          <div class="container-alb" >
            <div style="margin-left: 30px;">
              <h3 >Informatii cont upmobil (codclient / userlogin / data creare cont)</h3>
              <div 
              v-for="(coreAccount, index) in this.beneficiary.core_data"
              :key="index" 
              >
              <p> {{ $t("searchByClientCode") + ": " + coreAccount.codhd }} &nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;  {{ coreAccount.userlogin_legacy }}  &nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp; {{ coreAccount.created }}</p>
            </div>
          </div>
        </div>

        <template v-if="beneficiaryCoreAccounts">
            <div
            v-for="(entry, index) in beneficiaryCoreAccounts"
            
            :key="index"
            class="box-left "
            :class="index % 2 === 1 && 'clear-none'"
            >
            <div class="container-alb">
              <div class="usage-volume-container">
                <img
                :src="require('@/assets/images/logo-up-' +
                  (entry.product > 1500 ? '15' : entry.product) +
                  '.png')
                  "
                  />
                  <br />
                  <div v-if="entry.card && entry.card !== null">
                    <div class="grey-card">
                      <p align="center">
                        {{ $t("searchByClientCode") + ": " + entry.customer_id }}
                        <br />
                        {{ $t("orderExcelColumn_8") + ": " + entry.card.addressCode }}
                        <br />
                        {{ $t("cardNumberLabel") }}
                        {{ entry.card && entry.card.pan }}
                        <br />
                        {{ $t("beneficiariesTableCardStatus") + ": " }}
                        <span  class="status-background" :class="getClassForCardStatus(entry.card.state)" >{{ $t("cardStatus_" + entry.card.state) }}</span>
                        <br />
                        {{ $t("beneficiariesTableCardType") + ": " }}
                        {{ entry.card.virtual ? $t('beneficiariesTableCardTypeVirtual') : $t('beneficiariesTableCardTypePhysical') }}
                        <br />
                        {{
                          entry.card &&
                          $t("cardExpiryLabel") + " " + entry.card.expire
                        }}
                        <!-- {{
                            $t("currentBalanceLabel") +
                              " " +
                              entry.spent +
                              " " +
                              $t("currency")
                        }} -->
                      </p>
                      <div class="text-center">
                        <template v-for="(event, index) in entry.card.events">
                          <span :key="index" class="status-background" :class="getClassForCardStatus(event.type)">{{
                            $t("cardStatus_" + event.type) }}</span>
                          </template>
                        </div>
                    </div>
                    <div class="text-center d-flex">
                    <!-- <a
                      v-if="
                        (entry.card.state === 'A' || entry.card.state === 'C') && entry.card.virtual  "
                      class="notification-outline"
                      @click="confirmCardAction(entry, 'CLO')"
                      >{{ $t("issueCardButtonLabel") }}</a
                    > -->
                    <a
                      v-if="
                        (entry.card.state === 'A' || entry.card.state === 'C')"
                      class="notification-outline"
                      @click="confirmCardAction(entry, 'ADDAP')"
                      >{{ $t("addCardButtonLabel") }}</a
                    >
                    <a
                      v-if="
                        entry.card.state === 'A' || entry.card.state === 'C'
                      "
                      class="notification-outline"
                      @click="confirmCardAction(entry, 'BLOK')"

                      >{{ $t("blockCardButtonLabel") }}</a
                    >
                    <a
                      v-if="
                        entry.card.state === 'B'
                      "
                      class="notification-outline"
                      @click="confirmCardAction(entry, 'DBLOK')"

                      >{{ $t("unblockCardButtonLabel") }}</a
                    >
                    <a
                      v-if="entry.card.state === 'C'"
                      class="notification-outline"
                      @click="confirmCardAction(entry, 'ACT')"

                      >{{ $t("activateCardButtonLabel") }}</a
                    >
                  </div>
                  </div>
                </div>
              </div>
            </div>
        </template>
      </div>
      </div>
    </div>
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a
          @click="
            refresh ? redirectToSearchPage() : showModalPopup('modal_popup_info', false)
            "
          class="close-button"
        >
          <img src="@/assets/images/close-button.svg" />
        </a>
        <p
          v-if="this.actionError"
          v-html="$t('errorActionBeneficiary_' + this.actionError.code)"
        ></p>
        <p v-if="this.successMessage">{{ this.successMessage }}</p>

        <div v-if="this.actionOrderErrors">
          <p
            v-for="(error, index) in this.actionOrderErrors"
            :key="index"
            class="trhover"
            :class="index % 2 === 0 && 'gri-cell'"
          >
            {{ $t(error.error_code, { name: error.from_source_id }) }}
          </p>
        </div> 
      </div>
    </div>
     <div id="modal_popup_delete_mobile_account" class="modal-popup">
      <div class="modal-popup-content content-delete" v-if="this.beneficiarySubscriptions">
        <a @click="showModalPopup('modal_popup_delete_mobile_account', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
          <div class="">
            <h3 class="table-title">{{ this.beneficiarySubscriptions.title }}</h3>
            <br />
            <h6>{{ this.beneficiarySubscriptions.description }}</h6>
          <div class="pay_content scroll-window" >
            <table cellpadding="10" cellspacing="0" width="95%" class="hover-table invoices-table " align="center" v-if="beneficiarySubscriptions.subscriptions" >
              <tbody>
                <template v-for="(subs, index) in beneficiarySubscriptions.subscriptions">
                  <tr :key="index" class="trhover parent" :class="index % 2 === 0 && 'gri-cell'">
                    <td  style="text-align:left" valign="middle">
                      <strong>{{ subs.description }}</strong>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
            <br />
            <div class="d-flex justify-content-around">
            <a class="notification-action" @click="deleteMobileAccount()">
              {{ $t("saveChangesLabel") }}
            </a>
            <a class="notification-action" @click="showModalPopup('modal_popup_delete_mobile_account', false)">
                {{ $t("closePopupButtonLabel") }}
              </a>
              </div>
          </div>

        </div>
        <br />
        <div v-if="this.deleteAccountError">
          <span class="culoare-13 d-block">{{ $t("updateOUGError_" + deleteAccountError.error_code, { percent: deleteAccountError.description }) }}</span>
          <br />
        </div>
      </div>
    </div>
    <div id="modal_popup_loading" class="modal-popup">
      <div class="modal-popup-content">
        <img src="@/assets/images/loading.gif" />
        <p v-html="$t('loadingPopupMessage')"></p>
      </div>
    </div>
  </div>
</template>

<script>
  import httpServiceBenef from "@/http/http-ben-support.js";
  import httpServiceCustomer from "@/http/http-customer.js";
  import utils from "@/plugins/utils.js";
  import moment from "moment";
  import Cookies from "js-cookie";
  import $ from "jquery";
  import BeneficiaryAccountsTable from "@/components/company/beneficiaries-support/BeneficiaryAccountsTable.vue";

  export default {
    props: {
      beneficiaryId: Number,
      user: Object,
      userRole: String,
    },
    components: {
      BeneficiaryAccountsTable,
    },
    data() {
      return {
        beneficiary: null,
        beneficiaryPlus: null,
        beneficiaryCoreAccounts: null,
        actionOrderErrors: null,
        accountLoaded: false,
        historyDetails: null,
        choosenAccount: null,
        beneficiaryDataError: null,
        actionError: null,
        successMessage: null,
        formData: null,
        editMode: false,
        detailsMobile: false,
        selectedHistoryDetails: null,
        search: "",
        sortBy: "date",
        reverse: true,
        refresh: false,
        config: null,
        beneficiarySubscriptions: null,
        deleteAccountError: null,
      };
    },
    methods: {
      getBeneficiaryDetails() {
        if (this.beneficiary.up_uuid) {
          this.getBeneficiaryDetailsPlus();
        } else {
          this.beneficiaryPlus = {};
        }
        if (this.beneficiary.core_data) {
          // for (let index in this.beneficiary.core_data) {
          this.getBeneficiaryDetailsCore(this.beneficiary.core_data[0])
          // }
        } else {
          this.beneficiaryCoreAccounts = []
        }
      },
      getBeneficiaryDetailsPlus() {
        httpServiceBenef.beneficiariesService
          .getBeneficiaryDetails(
            this.beneficiary.up_uuid,
            this.accessToken
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.showModalPopup("modal_popup_loading", false, null, this.action);
          })
          .then((response) => {
            if (response.status == 200) {
              this.beneficiaryPlus = response.data;
              /* this.beneficiary.accounts[0].card.state = 'A';
              this.beneficiary.accounts[0].card.virtual = true;
  */
              this.resetBeneficiaryDetails();
              this.$forceUpdate();
              this.showModalPopup("modal_popup_loading", false, null, this.action);
            } else if (response.status == 400 || response.status == 403) {
              this.beneficiaryPlus = null;
            }
          });
      },
      getBeneficiaryDetailsCore(coreData) {
        if (!coreData) {
          coreData = this.beneficiary.core_data[0];
        }
        httpServiceBenef.beneficiariesService
          .getBeneficiaryDetailsCore(
            coreData.holder_id,
            this.accessToken
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.showModalPopup("modal_popup_loading", false, null, this.action);
          })
          .then((response) => {
            if (response.status == 200) {
              this.beneficiaryCoreAccounts = response.data;
              this.accountLoaded = true;
            } else if (response.status == 400 || response.status == 403) {
            }
          });
      },
      getBeneficiarySubscriptions() {
        this.showModalPopup("modal_popup_loading", true);
        httpServiceBenef.beneficiariesService
          .getBeneficiarySubscriptions(
            this.beneficiary.up_uuid,
            this.accessToken
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
          })
          .then((response) => {
            if (response.status == 200) {
              this.beneficiarySubscriptions = response.data;
              this.showModalPopup('modal_popup_delete_mobile_account', true);
            } else if (response.status == 400 || response.status == 403) {
              this.beneficiarySubscriptions = [];
            }
            this.showModalPopup("modal_popup_loading", false, null, this.action);
          });
      },
      showDeleteMobileAccountPopup(){
        this.getBeneficiarySubscriptions();
      },
      deleteMobileAccount() {
        this.successMessage = null;
        this.showModalPopup("modal_popup_loading", true);
        this.actionError = null;
        httpServiceBenef.beneficiariesService
          .deleteMobileAccount(
            this.beneficiary.up_uuid,
            this.beneficiarySubscriptions,
            this.accessToken
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {
            if (response.status == 200) {
              this.actionError = null;
              this.successMessage = this.$t("deleteMobileAccountSucceess");
              this.refresh = true;
              // this.$emit("personChanged");
              // window.location.reload();
            } else if (response.status == 400) {
              this.error = { code: response.code };
            } else {
              this.error = { code: response.status };
            }
            this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup('modal_popup_delete_mobile_account', false);
            this.showModalPopup("modal_popup_info", true);
          });
      },
      cancelDeleteMobileAccount() {
        this.successMessage = null;
        this.showModalPopup("modal_popup_loading", true);
        this.actionError = null;
        httpServiceBenef.beneficiariesService
          .cancelDeleteMobileAccount(
            this.beneficiary.up_uuid,
            // this.beneficiarySubscriptions,
            this.accessToken
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {
            if (response.status == 200) {
              this.actionError = null;
              this.successMessage = this.$t("deleteMobileAccountSucceess");
              this.refresh = true;
              // this.$emit("personChanged");
              // window.location.reload();
            } else if (response.status == 400) {
              this.error = { code: response.code };
            } else {
              this.error = { code: response.status };
            }
            this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          });
      },
      updateMobileTransactions() {
        this.successMessage = null;
        this.showModalPopup("modal_popup_loading", true);
        this.actionError = null;
        httpServiceBenef.beneficiariesService
          .updateMobileAccount(
            this.beneficiary.up_uuid,
            {
              mobile_data: 'mockup'
            },
            this.accessToken
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {
            if (response.status == 200) {
              this.actionError = null;
              this.successMessage = this.$t("updateMobileAccountSucceess");
              // this.$emit("personChanged");
              // window.location.reload();
            } else if (response.status == 400) {
              this.error = { code: response.code };
            } else {
              this.error = { code: response.status };
            }
            this.showModalPopup("modal_popup_loading", false);
            this.showModalPopup("modal_popup_info", true);
          });
      },
      confirmCardAction(accountEntity, action) {
        this.actionOrderErrors = null;
        this.refresh = false;
        this.successMessage = null;
        let cardsActionData = {
          id: 0,
          type: action,
          customer_id: accountEntity.company_id,
          product: (accountEntity.product + "").substring(0, 2),
        };
        this.showModalPopup(
          "modal_popup_loading",
          true,
        );
        httpServiceBenef.beneficiariesService
          .cardsAction(cardsActionData,
            accountEntity.id,
            accountEntity.card.id,
            this.accessToken,
            this.userRole
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {
            if (response.status === 200) {
              this.actionSuccess = true;
              this.actionError = null;
              // this.beneficiaryCoreAccounts = null;
              this.accountLoaded = false;
              this.getBeneficiaryDetailsCore();
              this.successMessage = this.$t("actionSuccessMessage", {
                action: this.$t("cardsAction_" + action)
              });
              this.showModalPopup("modal_popup_loading", false);
              // this.refresh = true;
              this.$forceUpdate();
            } else {

              this.getResponseErrors(response);
            }

            this.showModalPopup("modal_popup_info", true);
            // setTimeout(() => {
            //   this.beneficiary = null;
            //   this.getBeneficiaryDetails();
            // }, 1000);
          })
      },
      getBeneficiaryHistory() {
        httpServiceCustomer.customerService
          .getBeneficiaryHistory(
            this.customer.company_id,
            this.beneficiaryId,
            this.accessToken
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.showModalPopup("modal_popup_loading", false, null, this.action);
            this.historyDetails = null;
          })
          .then((response) => {
            if (response.status == 200) {
              this.historyDetails = response.data;
            } else {
              this.historyDetails = null;
            }
          });
      },
      getProductNameMethod(productId) {
        return utils.getCompanyProductName(productId, this.customer.products);
      },
      displayDate(date) {
        return moment(new Date(date), "YYYY-MM-DDThh:mm:ss").format("DD/MM/YYYY");
      },
      showModalPopup(
        elementId,
        show,
      ) {
        if (show) {
          document.getElementById(elementId).style.visibility = "visible";
        } else {
          document.getElementById(elementId).style.visibility = "hidden";
        }
      },
      getResponseErrors(response) {
        this.actionOrderErrors = null;
        if(response.headers["link"]){
          let errorsLink = response.headers["link"].split(";")[0];
          errorsLink = errorsLink.replace(">", "");
          errorsLink = errorsLink.replace("<", "");
          if (errorsLink.includes("exceptions_type")) {
            httpServiceCustomer.customerService
              .getOrderErros(errorsLink, this.accessToken)
              .then((response) => {
                if (response.status === 200) {
                  this.actionOrderErrors = response.data.errors;
                  this.error = { code: "ERROR" };
                }
              })
              .catch((error) => {
                if (error.response.data) {
                  this.error = { code: error.response.data.code };
                } else if (error.response.status === 409) {
                  this.error = { code: "409" };
                } else {
                  this.error = { code: "500" };
                }
              });
          }
        }
        this.showModalPopup("modal_popup_loading", false);
        this.showModalPopup("modal_popup_info", true);
      },
      editBeneficiaryDetails() {
        this.editMode = true;
        this.action = "MODIFY_DATA";
        $("#beneficiaryFirstName").prop("disabled", false);
        $("#beneficiaryLastName").prop("disabled", false);
        $("#beneficiaryMobilePhone").prop("disabled", false);
        $("#beneficiaryEmail").prop("disabled", false);
      },
      deleteBeneficiary() {
        this.showModalPopup("modal_popup_loading", true, null, this.action);
        this.actionError = null;
        this.successMessage = null;
        let beneficiaryData = this.beneficiary;
        beneficiaryData.mobile_phone = this.formData.mobilePhone;
        beneficiaryData.email = this.formData.email;
        httpServiceCustomer.customerService
          .deleteBeneficiary(
            this.customer.company_id,
            this.beneficiary.up_uuid,
            this.accessToken
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            this.actionError = { code: error.response.data.code };
            this.beneficiaryDataError = { code: error.response.code };
            this.showModalPopup("modal_popup_loading", false, null, this.action);
            this.showModalPopup("modal_popup_info", true, null, this.action);
          })
          .then((response) => {
            if (response.status == 200) {
              this.beneficiary = response.data;
              this.actionError = null;
              this.successMessage = this.$t("deleteDataSucceess");
              this.showModalPopup(
                "modal_popup_loading",
                false,
                null,
                this.action
              );
              this.showModalPopup("modal_popup_info", true, null, this.action);
              this.$emit("personChanged");
              // window.location.reload();
            } else if (response.status == 400) {
              this.beneficiaryDataError = { code: response.code };
            } else {
              this.beneficiaryDataError = { code: response.code };
            }
          });
      },
      submitBeneficiaryDetails() {
        this.showModalPopup("modal_popup_loading", true, null, this.action);
        this.actionError = null;
        this.successMessage =null;
        let beneficiaryData = this.beneficiary;
        beneficiaryData.mobile_phone = this.formData.mobilePhone;
        beneficiaryData.email = this.formData.email;
        httpServiceCustomer.customerService
          .modifyBeneficiaryData(
            this.customer.company_id,
            {
              up_uuid: this.beneficiary.up_uuid,
              last_name: this.formData.lastName,
              first_name: this.formData.firstName,
              mobile_phone: this.formData.mobilePhone,
              email: this.formData.email,
              active:
                this.action === "INACTIVATE"
                  ? false
                  : this.action === "ACTIVATE"
                    ? true
                    : this.beneficiary.active
            },
            this.accessToken
          )
          .then(function (response) {
            return response;
          })
          .catch((error) => {
            return error.response;
          })
          .then((response) => {
            if (response.status == 200) {
              this.beneficiary = response.data;
              this.actionError = null;
              this.successMessage = this.$t("modifiyDataSucceess");
              this.editMode = false;
              this.resetBeneficiaryDetails();
              this.showModalPopup(
                "modal_popup_loading",
                false,
                null,
                this.action
              );
              // this.showModalPopup("modal_popup_info", true, null, this.action);
              this.$emit("personChanged");

              // window.location.reload();
            } else if (response.status == 400) {
              this.beneficiaryDataError = { code: response.data.error_code };
            } else {
              this.beneficiaryDataError = { code: response.data.error_code };
            }

            // this.actionError = { code: error.response.data.code };
            // this.beneficiaryDataError = { code: error.response.code };
            this.showModalPopup("modal_popup_loading", false, null, this.action);
            this.showModalPopup("modal_popup_info", true, null, this.action);
          });
      },
      resetBeneficiaryDetails() {
        this.formData = {
          lastName: this.beneficiary.last_name,
          firstName: this.beneficiary.first_name,
          cnp: this.beneficiary.cnp,
          // mobilePhone: this.beneficiary.mobile_phone,
          // email: this.beneficiary.email
        };
        this.editMode = false;
        $("#beneficiaryFirstName").prop("disabled", true);
        $("#beneficiaryLastName").prop("disabled", true);
        $("#beneficiaryMobilePhone").prop("disabled", true);
        $("#beneficiaryEmail").prop("disabled", true);
      },
      selectHistoryDetailsMobile(index) {
        this.selectedHistoryDetails = this.filterHistory[index];
        this.detailsMobile = !this.detailsMobile;
      },
      changeReverse() {
        this.reverse = !this.reverse;
      },
      getValueForSort(entry) {
        switch (this.sortBy) {
          case "product":
            return this.getProductNameMethod(entry[this.sortBy]);
          case "order_type":
            return this.$t("orderType_" + entry.order_type);
          default:
            return entry[this.sortBy];
        }
      },
      onlyAlphabetCharacters(variable) {
        if (/^[a-zA-Z-]*$/i.test(variable)) {
          return variable;
        } else {
          return variable.replace(/[0-9&\/\\|`#@\[\]\,+=()$~%.'":*!?<>{}]/g, "");
        }
      },
      onlyNumericCharacters(variable) {
        if (/^[0-9]*$/i.test(variable)) {
          return variable;
        } else {
          return variable.replace(
            /[a-zA-Z&\/\\|`#@\[\]\-,+=()$~%.'":*!?<>{}]/g,
            ""
          );
        }
        return variable;
      },
      updateInputCharacters() {
        this.formData.lastName = this.onlyAlphabetCharacters(
          this.formData.lastName
        );
        this.formData.firstName = this.onlyAlphabetCharacters(
          this.formData.firstName
        );
        this.formData.mobilePhone = this.onlyNumericCharacters(
          this.formData.mobilePhone
        );
        this.beneficiary.security_code = this.onlyNumericCharacters(
          this.beneficiary.security_code
        );
        this.$forceUpdate();
      },
      refreshPage() {
        this.beneficiary = null;
        this.getBeneficiaryDetails();
      },
      redirectToSearchPage() {
        this.pushRoute('support_beneficiaries_search');
      },
      getClassForCardStatus(status) {
        switch (status) {
          case "A":
            return "background-active";
          case "B":
          case "F":
          case "RC":
            return "background-blocked";
          case "D":
            return "background-deactivated";
          case "C":
          case "X":
          case "RNN":
            return "background-inactive";
          case "J":
          case "L":
            return "background-cancelled";
          case "E":
          case "I":
          case "M":
          case "N":
          case "O":
          case "P":
          case "R":
          case "S":
          case "RN":
          case "RNV":
          case "RNY":
          case "RP":
            return "background-will-expire";
          case "D_APP":
            return "background-deactivated";
          default:
            return "background-active";
        }
      },
    },
    computed: {
      filterHistory: function () {
        var returnHistoryDetails = this.historyDetails;
        const result = returnHistoryDetails.sort((a, b) =>
          this.getValueForSort(a) < this.getValueForSort(b)
            ? -1
            : a[this.sortBy] !== b[this.sortBy]
        );
        return this.reverse ? result.reverse() : result;
      },
    },
    created() {
      this.accessToken = Cookies.get("token");
      this.beneficiary = JSON.parse(localStorage.getItem("selected_beneficiary"));
      this.resetBeneficiaryDetails();
      this.getBeneficiaryDetails();
      // this.getBeneficiaryHistory();

    },
    mounted() {
      this.config = JSON.parse(sessionStorage.getItem("mobile_jsonFile"));
    }
  };
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<style scoped>
  .notification-outline {
    display: block;
    width: 30%;
    padding-left: 55px;
    padding-right: 55px;
    padding-top: 12px;
    height: auto;
    padding-bottom: 12px;
    background: #fff;
    color: #f49400;
    border: 1px solid #f49400;
    font-weight: bold;
    text-decoration: none;
    border-radius: 5px;
    border-bottom: 2px solid #ddd;
    text-transform: uppercase;
    text-align: center;
    margin: 10px auto;
    cursor: pointer;
  }

.content-delete{
  	width: 451px !important;
  	max-width: 451px !important;

}

  .clear-none {
    clear: none;
  }

  .beneficary-details-page .custom-notification-action {
    display: inline-block;
    width: auto;
  }

  .beneficary-details-page .left {
    display: inline-block;
    width: 50%;
  }

  .beneficary-details-page .right {
    display: inline-block;
    width: 50%;
  }

  .beneficary-details-page .right .notification-action {
    margin-left: 10px;
  }

  .resetButton:not([href]):not([tabindex]) {
    text-decoration: underline;
    color: #585858;
    font-style: italic;
    cursor: pointer;
  }

  .benef {
    position: relative;
    z-index: 9;
  }

  .disabled {
    background-color: #9b9b9b !important;
  }

  @media (max-width: 1003px) {
    .beneficary-details-page {
      width: 95%;
      margin: 0 auto;
    }
  }

  @media (max-width: 768px) {
    .beneficary-details-page .custom-notification-action {
      display: inline-block;
      width: auto !important;
      padding: 10px;
      background-image: none;
    }

    .notification-outline {
      display: block;
      width: 100%;
      padding: 0px;
      padding-top: 12px;
      height: auto;
      padding-bottom: 12px;
      background: #fff;
      color: #f49400;
      border: 1px solid #f49400;
      text-decoration: none;
      border-radius: 5px;
      border-bottom: 2px solid #ddd;
      text-transform: uppercase;
      text-align: center;
      margin: 10px auto;
    }

    .grey-card .notification-outline {
      width: auto;
      margin: 10px;
      display: inline-block;
      padding: 10px;
    }
  }
</style>
